/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualEntryReason1
 */
export interface ManualEntryReason1 {
}

/**
 * Check if a given object implements the ManualEntryReason1 interface.
 */
export function instanceOfManualEntryReason1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ManualEntryReason1FromJSON(json: any): ManualEntryReason1 {
    return ManualEntryReason1FromJSONTyped(json, false);
}

export function ManualEntryReason1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualEntryReason1 {
    return json;
}

export function ManualEntryReason1ToJSON(value?: ManualEntryReason1 | null): any {
    return value;
}

